import script from "./PositionsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PositionsView.vue?vue&type=script&lang=ts&setup=true"

import "./PositionsView.vue?vue&type=style&index=0&id=04b96860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b96860"]])

export default __exports__